/** @format */
'use client';
import CompanySelect from '@/app/[locale]/ui/CompanySelect';
import CurrencySelect from '@/app/[locale]/ui/CurrencySelect';
import LocaleSelect from '@/app/[locale]/ui/LocaleSelect';
import SessionTime from '@/app/[locale]/ui/SessionTime';
import { useConfigStore } from '@/providers/ConfigStoreProvider';
import { Role } from '@common/application/enums/Role';
import { StorageKey } from '@common/application/enums/StorageKey';
import useUserRoles from '@common/application/hooks/useUserRoles/useUserRoles';
import useProfilePhoto from '@common/application/hooks/useProfilePhoto/useProfilePhoto';
import UserIconBig from '@quarks/UserIconBig';
import SelectBox from 'devextreme-react/select-box';
import { signOut, useSession } from 'next-auth/react';
import Image from 'next/legacy/image';
import { useRouter } from 'next/navigation';
import { FormattedMessage } from 'react-intl';
import { useSessionStorage } from 'usehooks-ts';
import styles from './UserMenu.module.css';

export function UserMenu(props) {
  const { data: session } = useSession();
  const photoUrl = useProfilePhoto();
  const router = useRouter();
  const initials = session?.user?.name?.split(' ').map((name) => name[0]);
  const { impersonatedRole, role, setImpersonatedRole } = useConfigStore((s) => s);
  const [sessionImpersonatedRole, setSessionImpersonatedRole] = useSessionStorage(StorageKey.IMPERSONATED_ROLE, null);

  const { roles } = useUserRoles();
  const isAdmin = roles.includes(Role.Admin);

  return (
    <div className={styles.wrapper}>
      <div className={styles.section}>
        <UserIconBig>{photoUrl ? <Image src={photoUrl} layout="fill" objectFit="cover" alt={'User Avatar'} /> : initials}</UserIconBig>
        <div className={styles.sectionText}>
          <span>{session?.user?.name}</span>
          <span className={styles.subtext}>{session?.user?.email}</span>
        </div>
      </div>
      <div className={styles.section}>
        <span className={styles.sessionText}>
          <SessionTime />
        </span>
      </div>
      <div className={styles.section}>
        <div className={styles.selects}>
          {isAdmin && (
            <SelectBox
              dataSource={roles}
              label={'Role'}
              value={impersonatedRole ?? role}
              onValueChanged={(e) => {
                setSessionImpersonatedRole(e.value);
                setImpersonatedRole(e.value as Role);
              }}
            />
          )}
          <LocaleSelect />
          <CurrencySelect />
          <CompanySelect />
        </div>
      </div>
      <div className={styles.linksWrapper}>
        <span
          onClick={() => {
            router.push('/settings');
            if (props.onClose) {
              props.onClose();
            }
          }}
          className={styles.link}
        >
          <FormattedMessage defaultMessage="Settings" description="Link to the settings/preferences page" />
        </span>
        <span onClick={() => signOut()} className={styles.link}>
          <FormattedMessage defaultMessage="Sign Out" description="User menu sign out link text" />
        </span>
      </div>
    </div>
  );
}
